<div class="insight-container">
  <div class="insight__border left-top"></div>

  <div class="insight__border left-bottom"></div>
  <div class="insight__border right-top"></div>
  <div class="insight__border right-bottom"></div>

  <div class="insight-wrapper">
    <div>
    <ng-content select=".insight__header">

    </ng-content>
  </div>
    <div>
    <ng-content select=".insight__middle">

    </ng-content>
  </div>
    <div>
    <ng-content select=".insight__down">

    </ng-content>
  </div>
  </div>

</div>
